module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.4.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.4.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.5.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.402.589.1400.817.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.0.0.box.402.589.865.58.q.60"
    }
  }, [_vm._v("“You cannot teach a crab to walk straight.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.6.0.1.box.1530.643.271.58.q.80"
    }
  }, [_vm._v("Aristophanes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.0.2.box.402.751.389.59.q.60"
    }
  }, [_vm._v("“Thank goodness.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.6.0.3.box.1542.806.260.58.q.70"
    }
  }, [_vm._v("Judy Colbert")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.0.4.box.402.914.211.46.q.70"
    }
  }, [_vm._v("Thanks to:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.5.box.402.981.1400.160.q.60"
    }
  }, [_vm._v("Each and every person who contributed a recipe, an idea, a photograph, a concept, and knowledge about the Chesapeake Bay, its watermen, and its blue crabs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.6.box.402.1143.1400.167.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.6.0"
    }
  }), _vm._v("Joyce A. Stinnett Baki, Calvert County Department of Economic Development, and Aubrey Manzo, Southern Delaware Tourism, who gave so much time and provided so much assistance.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.7.box.402.1306.1400.100.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  }), _vm._v("Jack Brooks at J. M. "), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.6.0"
    }
  }), _vm._v("Clayton Co. and Mike "), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.16.0"
    }
  }), _vm._v("and Don Storm at Shor"), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.23.0"
    }
  }), _vm._v("eline Seafood.")]), _c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 10",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 54
// module chunks = 0